<template>
    <b-modal ref="profile_modal"
             size="lg"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>


        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.item.uniq_id}} TYPE: {{ this.type }}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <div class="panel-content">
                    <info_field f_uniq="ct" f_type="title"
                                :is_disabled="false"
                                @update_categ="change_atr"
                                :f_title="__t('NAME')" :f_val="item.title"></info_field>

                    <info_field f_uniq="ct" f_type="uniq_id"
                                :is_disabled="is_edit"
                                @update_categ="change_atr"
                                :f_title="__t('UNIQ_ID')" :f_val="item.uniq_id"></info_field>
                </div>
            </div>
        </div>



        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">

                <button type="button" @click="remove(false)" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5">
                    {{ __t('REMOVE') }}
                </button>

                <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>

                <button type="button" v-on:click="save" class="btn btn-primary waves-effect waves-themed">
                    {{ __t('SAVE') }}
                </button>
            </div>
        </template>


    </b-modal>
</template>

<script>
import Info_field from "../../../sys/info_field";

export default {
    name: "add_org_types",
    components : {
      Info_field
    },

    props : {
        modal_position : {
            type : String,
            default : "left"
        },
    },

    data() {
        return {
            is_show_modal : false,
            type : "",
            item : {
                id : 0,
                title : "",
                uniq_id : "",
                org_id : 0,
            }
        }
    },

    created() {
      EventBus.$on('make_type_org',this.set_org_info)
    },

    methods : {
        change_atr(atr_name,atr_val) {
            if(this.item.hasOwnProperty(atr_name)) {
                this.item[atr_name] = atr_val;
            }
        },

        set_org_info(type,item,org_id) {
            this.type = type;
            this.org_id = org_id;
            this.is_show_modal = true;

            if(this.obj_to_null(item)) {
                this.item = item;
            }
        },


        close () {
            this.item = {
                id : 0,
                title : "",
                uniq_id : "",
            }

            this.is_show_modal = false;
            EventBus.$emit('reload_org_type',this.type);
        },


        async remove() {
            await api.delete('/internal/v1/catalog/organizations/'+ parseInt(this.org_id) +'/' + this.type + "/" + this.item.id).then(({data}) => {
                if (data.status === "operation_success") {
                    this.close();
                }

            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },


        async save() {
            await api.put('/internal/v1/catalog/organizations/'+ parseInt(this.org_id) +'/' + this.type,this.item).then(({data}) => {
                if (data.status === "operation_success") {
                    this.close();
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        }
    },

    computed : {

        is_edit () {
            return parseInt(this.item.id)  > 0;
        },

        dialog_class_draw () {
            if (this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        }
    }
}
</script>

<style scoped>

</style>
